import { useNavigate } from "react-router-dom";
import { Button, EmptyState } from "@/components/ui";
import { ROUTES } from "@/constants/routes";
import { useAuthStore } from "@/store";

export default function NotFoundPage() {
  const navigate = useNavigate();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  return (
    <div className="flex min-h-svh items-center justify-center bg-bg p-6">
      <EmptyState
        title="Page not found"
        description="That route does not exist yet."
        action={
          <Button
            onClick={() =>
              navigate(isAuthenticated ? ROUTES.dashboard : ROUTES.login)
            }
          >
            {isAuthenticated ? "Back to dashboard" : "Go to login"}
          </Button>
        }
      />
    </div>
  );
}
